import React from 'react'
import {
  CANCEL_BTN_ATTRIBUTES,
  SUBMIT_MODAL_ATTRIBUTES,
  SUBMIT_TEST_BTN_ATTRIBUTES,
} from "@app/constants"
import ItemList from "../../containers/ItemListContatainer"
import { BasicModal } from "../BasicModal"
import { SubmitModalLayout } from "./SubmitModalLayout"
import { getTerm } from '@app/helpers/workkeysReplaceTerms'

type Props = {
  open: boolean
  onClose: () => void
  onSubmit: () => void
  onExited?: () => void
  hasUnansweredItems?: boolean
  onSelectItem: (id: string) => () => void
  isLinearMode?: boolean
  duration?: number
}

const modalTitle = `Are you ready to submit your ${getTerm('test')}?`

export const SubmitTestModal: React.FC<Props> = ({
  open,
  onClose,
  onSubmit,
  onExited,
  hasUnansweredItems = false,
  onSelectItem,
  isLinearMode = false,
  duration = 0,
}) => {
  return (
    <BasicModal
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      onExited={onExited}
      size="md"
      title={modalTitle}
      submitText={'Submit Answers'}
      modalProps={SUBMIT_MODAL_ATTRIBUTES}
      submitButtonProps={SUBMIT_TEST_BTN_ATTRIBUTES}
      cancelButtonProps={CANCEL_BTN_ATTRIBUTES}
    >
      <SubmitModalLayout duration={duration}>
        {hasUnansweredItems ? (
          <ItemList
            onClick={onSelectItem}
            openSubmitModal={open}
            isLinearMode={isLinearMode}
            showAnsweredStatus={true}
            navigationBubbleProps={{
              variant: 'outlined',
              dense: true,
            }}
          />
        ) : null}
      </SubmitModalLayout>
    </BasicModal>
  )
}
